export const TickIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="10" height="8">
		<path
			fill="#fff"
			d="M8.6507.1732a.4687.4687 0 0 1 .0347.662L3.095 7.044a.4666.4666 0 0 1-.2012.1315c-.0071.0013-.0138.0036-.0205.0058a.2673.2673 0 0 1-.029.0076.4668.4668 0 0 1-.463-.1403L.1731 4.596a.4688.4688 0 0 1 .6967-.6273l1.866 2.072L7.9886.208a.4688.4688 0 0 1 .662-.0347Z"
		/>
	</svg>
);
